import { render, staticRenderFns } from "./MonitoringHistoryCoordinates.vue?vue&type=template&id=37e68c5a"
import script from "./MonitoringHistoryCoordinates.vue?vue&type=script&lang=js"
export * from "./MonitoringHistoryCoordinates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports